// get all
export const FLAG_GETTING_TICKET_POSTPONE_PROCESSES =
  'FLAG_GETTING_TICKET_POSTPONE_PROCESSES';
export const GET_TICKET_POSTPONE_PROCESSES = 'GET_TICKET_POSTPONE_PROCESSES';
export const CLEAR_TICKET_POSTPONE_PROCESSES =
  'CLEAR_TICKET_POSTPONE_PROCESSES';

// get one
export const FLAG_TICKET_POSTPONE_PROCESS_ACTIVITY =
  'FLAG_TICKET_POSTPONE_PROCESS_ACTIVITY';
export const GET_TICKET_POSTPONE_PROCESS = 'GET_TICKET_POSTPONE_PROCESS';
export const CLEAR_TICKET_POSTPONE_PROCESS = 'CLEAR_TICKET_POSTPONE_PROCESS';
